export enum PromotionUrlOperation {
    is = 'is',
    isNot = 'isNot',
    contains = 'contains',
    doesntContain = 'doesntContain'
}

export enum PromotionCtaAction {
    click = 'click',
    copy = 'copy',
}

export enum CloseBehaviour {
    auto = 'auto',
    click = 'click'
}

export enum OpenBehaviour {
    auto = 'auto',
    clickTrigger = 'clickTrigger',
    exitIntent = 'exitIntent'
}

export enum AudienceTypes {
    once = 'once',
    always = 'always',
    custom = 'custom'
}

export enum DiscountTypes {
    Bundle = 'bundle',
    Dynamic = 'dynamic'
}
